import { render } from "./dltfu.vue?vue&type=template&id=34d127cd&scoped=true"
import script from "./dltfu.vue?vue&type=script&lang=js"
export * from "./dltfu.vue?vue&type=script&lang=js"

import "./dltfu.vue?vue&type=style&index=0&id=34d127cd&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d127cd"]])

export default __exports__